var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"echarts",staticStyle:{"width":"60%","height":"100px","margin":"auto"},attrs:{"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }